import React from "react";
import Context, { type Breadcrumb } from "./context";

const BreadcrumbsProvider = ({ children }) => {
	const [breadcrumbs, setBreadcrumbs] = React.useState<Breadcrumb[]>([]);
	return (
		<Context.Provider value={{ breadcrumbs, setBreadcrumbs }}>
			{children}
		</Context.Provider>
	);
};

export default BreadcrumbsProvider;
